export var environment = {
    production: false,
    environment: 'test',
    apiUrl: 'http://test-api.yourcompany.com:8087',
    appTitle: '论文格式处理工具',
    uploadMaxSize: 50, // MB
    enableDebug: false,
    logLevel: 'warn',
    apiTimeout: 60000, // ms
    fileDownloadExpiration: 48, // hours
    // FeedbackMail SDK配置
    feedbackSdk: {
        baseUrl: 'http://testserver.gopiqiu.com:8080',
        apiKey: 'fb_formatter_web_test_api_key_67890',
        websiteName: 'formatter_web_test',
        buttonIcon: '💬',
        buttonText: '意见反馈',
        position: 'bottom-right',
        timeout: 30,
        language: 'zh',
        debug: false
    },
    // Feature flags
    features: {
        advancedProcessing: true,
        debugPanel: false,
        testingTools: true,
    }
};
